<template>
    <div>
      <div
        uk-grid class="uk-flex uk-flex-middle uk-grid-small search-results-list"
        v-for="(location, $key) in stores"
        v-bind:location = "location.id"
        v-bind:key="$key"
        v-on:click="clickListItem(location.id, $event)"
      >
        <div class="logo uk-width-1-5 uk-text-center">
          <img v-bind:src="location.image" alt="" style="max-width: 25vw; max-height: 11vh;">
        </div>
        <div class="uk-width-3-5" style="width:70%!important; padding-left: 16vw; overflow: hidden; text-overflow:ellipsis;">
          <span class="font-size-14pt uk-bold">{{ location.name }}</span><br />
          <span class="font-size-8pt" style="/*white-space: nowrap;*/">
            <span v-if="location.address1 !== '' && location.address1 !== null ">{{ location.address1 }},</span>
            <span v-if="location.locality !== '' && location.locality !== null">{{ location.locality }},</span>
            <span v-if="location.region !== '' && location.region !== null">{{ location.region }}</span>
          </span>
        </div>
        <div class="next uk-width-1-5 uk-text-right" style="width: 10% !important;">
          <img src="../../assets/images/right-arrow-grey.png" alt="arrow-right" width="27" height="27">
        </div>
      </div>
    </div>
</template>

<script>
import _ from 'lodash'

import scrollPointMixin from '@/mixins/scrollPointMixin'

export default {
  mixins: [scrollPointMixin],
  props: ['results'],
  name: 'SearchResultsStores',
  computed: {
    stores () {
      return _.sortBy(this.results, 'distance')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Search/SearchResultsStores.vue